import React from "react";
import ReactJson from "react-json-view";
import { useTheme } from "../../../hooks/useTheme";

/**
 * Props do componente JsonViewer.
 */
interface JsonViewerProps {
  src: object | any[];
  name?: string;
  collapsed?: boolean | number;
  theme?: string;
}

/**
 * Componente wrapper para ReactJsonView com tema adaptativo.
 *
 * Adapta o tema do JSON viewer baseado no tema atual da aplicação (light/dark).
 *
 * @param src - Objeto ou array a ser exibido
 * @param name - Nome do objeto (opcional)
 * @param collapsed - Se deve iniciar colapsado (opcional)
 * @param theme - Tema customizado (opcional, sobrescreve tema automático)
 */
export const JsonViewer: React.FC<JsonViewerProps> = ({ src, name = "response", collapsed = true, theme: customTheme }) => {
  const { theme } = useTheme();

  // Seleciona tema baseado no tema da aplicação
  const jsonTheme = customTheme || (theme === "dark" ? "tube" : "rjv-default");

  /**
   * Função para remover aspas ao copiar valores string.
   *
   * Quando o usuário copia um valor do tipo string, remove as aspas duplas
   * automaticamente para facilitar o uso do valor copiado.
   *
   * @param copy - Objeto com dados da cópia do react-json-view
   * @returns false para prevenir comportamento padrão (quando string), true caso contrário
   */
  const handleCopy = (copy: any) => {
    const copiedValue = copy.src;

    // Se for uma string, remove as aspas e copia o valor puro
    if (typeof copiedValue === "string") {
      navigator.clipboard.writeText(copiedValue);
      return false; // Previne o comportamento padrão
    }

    // Para outros tipos (number, boolean, object, array), mantém o comportamento padrão
    return true;
  };

  return (
    <div
      style={{
        padding: "16px",
        borderRadius: "6px",
        backgroundColor: theme === "dark" ? "#1f1f1f" : "#fafafa",
        overflowX: "auto",
        overflowY: "visible",
        maxWidth: "100%",
      }}
    >
      <ReactJson src={src} name={name} theme={jsonTheme as any} collapsed={collapsed} quotesOnKeys={false} displayDataTypes={false} indentWidth={2} enableClipboard={handleCopy} />
    </div>
  );
};

export default JsonViewer;
